import React, { FC } from 'react';
import Button from 'shared/components/andtComponents/Button';
import Tooltip from 'shared/components/andtComponents/Tooltip';
import { GenerateIcon, ICONS } from '@pileus-cloud/anodot-frontend-common';

import styles from '../GovernanceTagsModal.module.scss';
import tooltipStyles from 'shared/components/andtComponents/Tooltip.module.scss';

const PlusIcon = () => <GenerateIcon iconName={ICONS.plus.name} />;

interface TagsHeaderProps {
  selectAll: boolean;
  tagsLength: number;
  hasEmptyTag: boolean;
  onSelectAll: (checked: boolean) => void;
  onAddTag: () => void;
}

const TagsHeader: FC<TagsHeaderProps> = ({ selectAll, tagsLength, hasEmptyTag, onSelectAll, onAddTag }) => {
  const canAddTag = !hasEmptyTag;
  const addTagTooltip = hasEmptyTag ? 'Please fill in all empty key/value fields before adding a new tag' : '';

  return (
    <div className={styles.selectAllAndActionsRow}>
      <div className={styles.selectAllRow}>
        <input
          type="checkbox"
          id="selectAllTags"
          checked={selectAll}
          onChange={(e) => onSelectAll(e.target.checked)}
          disabled={tagsLength === 0}
        />
        <label htmlFor="selectAllTags">Select all</label>
      </div>
      <div className={styles.actionButtons}>
        <Tooltip
        title={addTagTooltip}             
        classes={{ tooltip: tooltipStyles.whiteTooltip, arrow: tooltipStyles.whiteArrow }}
        placement="top">
          <span>
            <Button
              text="Add Virtual Tag"
              automationid="add-tag"
              icon={PlusIcon}
              onClick={onAddTag}
              className={styles.addButton}
              disabled={!canAddTag}
            />
          </span>
        </Tooltip>
      </div>
    </div>
  );
};

export default TagsHeader;
